"use client";
import { useEffect } from "react";

const HubSpotForm = () => {
  useEffect(() => {
    const interval = setInterval(() => {
      const form = document.querySelector(".hs-form-frame form");
      if (form) {
        let input = form.querySelector('input[name="page_url"]');
        if (!input) {
          input = document.createElement("input");
          input.type = "hidden";
          input.name = "page_url";
          form.appendChild(input);
        }
        input.value = window.location.href;
        clearInterval(interval);
      }
    }, 300);

    return () => clearInterval(interval);
  }, []);

  return (
    <div
      className="hs-form-frame"
      data-region="na2"
      data-form-id="bb1e8916-9ac9-4e8a-8623-cc3df4338391"
      data-portal-id="242012669"
    />
  );
};

export default HubSpotForm;
